"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _commonHelper = require("../../helpers/commonHelper");

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _inputHelper = require("../inputHelper");

var _misc = _interopRequireDefault(require("../../tokens/misc"));

var _teal = _interopRequireDefault(require("../../tokens/color/teal")); // libraries
// helpers
// import { green } from "../../tokens/color";


var RightIcon = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1yzxt5f-0"
})(["", ";position:absolute;top:15px;right:10px;"], _commonHelper.svgStyle);

var LeftIcon = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1yzxt5f-1"
})(["", ";position:absolute;top:15px;left:10px;"], _commonHelper.svgStyle);

var LeftLoader = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1yzxt5f-2"
})(["position:absolute;top:18px;left:10px;z-index:1;"]);

var RightLoader = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1yzxt5f-3"
})(["position:absolute;top:18px;right:10px;z-index:1;"]);

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      toggleFocus = _useState2[1]; // eslint-disable-next-line no-unused-vars


  var onFocusToggle = function onFocusToggle(_) {
    if (!focused) props.onFocus();
    toggleFocus(!focused);
  };

  var state = (0, _inputHelper.getState)(props, focused);
  var helperTxt = (0, _inputHelper.getHelperText)(props.helperText, props.errorMsg);
  var loading = props.loading,
      onChange = props.onChange,
      wrapperProps = (0, _objectWithoutProperties2["default"])(props, ["loading", "onChange"]); // fix: loading property should not be passed to native elemennts

  var inputProps = {
    name: props.name,
    min: props.min,
    type: props.type,
    width: props.innerWidth,
    icon: props.icon,
    disabled: props.disabled,
    borderColor: props.borderColor,
    autoFocus: props.autoFocus,
    value: props.value,
    leftIcon: props.leftIcon,
    ref: ref,
    fullWidth: props.fullWidth,
    onChange: (0, _inputHelper.onValueChange)(props) // fix: passing an onChange to input with a value property

  };
  return /*#__PURE__*/_react["default"].createElement(Input.Wrapper, (0, _extends2["default"])({}, wrapperProps, {
    fullWidth: props.fullWidth,
    onFocus: onFocusToggle,
    onBlur: (0, _inputHelper.onBlurred)(props, onFocusToggle)
  }), /*#__PURE__*/_react["default"].createElement(Input.ElementWrapper, {
    width: props.innerWidth
  }, props.leftIcon && /*#__PURE__*/_react["default"].createElement(LeftIcon, null, (0, _commonHelper.cloneChildren)(props.leftIcon, {
    size: 17,
    color: props.leftIconColor
  })), loading && props.loader && props.loaderAlign === "left" && /*#__PURE__*/_react["default"].createElement(LeftLoader, null, /*#__PURE__*/_react["default"].createElement(props.loader, props.loaderProps)), /*#__PURE__*/_react["default"].createElement(Input.Element, (0, _extends2["default"])({}, inputProps, {
    state: state,
    autoComplete: props.autocomplete ? "on" : "nope",
    leftLoader: props.loader && props.loaderAlign === "left",
    rightLoader: props.loader && props.loaderAlign === "right"
  })), loading && props.loader && props.loaderAlign === "right" && /*#__PURE__*/_react["default"].createElement(RightLoader, null, /*#__PURE__*/_react["default"].createElement(props.loader, props.loaderProps)), props.icon && /*#__PURE__*/_react["default"].createElement(RightIcon, null, (0, _commonHelper.cloneChildren)(props.icon, {
    size: 17,
    color: props.iconColor
  }))), props.disabled ? /*#__PURE__*/_react["default"].createElement(Input.LabelDisabled, {
    showLbl: true,
    state: state
  }, props.label) : /*#__PURE__*/_react["default"].createElement(Input.Label, {
    showLbl: focused || !!props.value,
    hideLabel: props.hideLabel,
    value: props.value,
    state: state,
    leftIcon: props.leftIcon,
    leftLoader: props.loader && props.loaderAlign === "left"
  }, props.label), props.showHelperText && /*#__PURE__*/_react["default"].createElement(Input.Helper, {
    state: state
  }, helperTxt));
});

Input.ElementWrapper = _styledComponents["default"].section.withConfig({
  componentId: "sc-1yzxt5f-4"
})(["position:relative;margin:0;width:", ";height:4.8rem;"], (0, _inputHelper.getAttributes)("width"));
Input.Helper = _styledComponents["default"].div.withConfig({
  componentId: "sc-1yzxt5f-5"
})(["height:13px;color:", ";visibility:", ";font-size:11px;line-height:13px;margin-top:2px;"], (0, _inputHelper.getAttributes)("helperColor"), (0, _inputHelper.getAttributes)("visibility"));
Input.Wrapper = _styledComponents["default"].section.withConfig({
  componentId: "sc-1yzxt5f-6"
})(["position:relative;width:", ";"], function (props) {
  return props.fullWidth ? "100%" : "auto";
});
Input.Label = _styledComponents["default"].label.withConfig({
  componentId: "sc-1yzxt5f-7"
})(["position:absolute;pointer-events:none;transition:0.2s ease all;color:", ";top:", ";left:", ";font-size:", ";background:", ";padding:", ";display:", ";max-width:90%;max-height:2.2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], (0, _inputHelper.getAttributes)("placeholder"), (0, _inputHelper.getLabelAttr)("top"), (0, _inputHelper.getLabelAttr)("left"), (0, _inputHelper.getLabelAttr)("fontSize"), (0, _inputHelper.getLabelAttr)("background"), (0, _inputHelper.getLabelAttr)("padding"), (0, _inputHelper.getLabelAttr)("display"));
Input.LabelDisabled = _styledComponents["default"].label.withConfig({
  componentId: "sc-1yzxt5f-8"
})(["position:absolute;pointer-events:none;color:", ";top:", ";left:", ";font-size:", ";background:", ";padding:", ";max-width:90%;max-height:2.2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], (0, _inputHelper.getAttributes)("placeholder"), (0, _inputHelper.getLabelAttr)("top"), (0, _inputHelper.getLabelAttr)("left"), (0, _inputHelper.getLabelAttr)("fontSize"), (0, _inputHelper.getLabelAttr)("labelBackground"), (0, _inputHelper.getLabelAttr)("padding"));
Input.Element = _styledComponents["default"].input.withConfig({
  componentId: "sc-1yzxt5f-9"
})(["padding:", ";height:4.8rem;background:", ";border:", " ", ";font-size:", ";width:", ";outline:none;&::-webkit-input-placeholder{color:#a9a9a9;}box-sizing:border-box;border-radius:", ";color:", ";"], (0, _inputHelper.getAttributes)("padding"), (0, _inputHelper.getAttributes)("background"), (0, _inputHelper.getAttributes)("borderWidth"), (0, _inputHelper.getAttributes)("borderColor"), (0, _inputHelper.getAttributes)("fontSize"), (0, _inputHelper.getAttributes)("width"), _misc["default"].radius, (0, _inputHelper.getAttributes)("text"));
Input.propTypes = {
  label: _propTypes["default"].string.isRequired,
  hideLabel: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  type: _propTypes["default"].string,
  innerWidth: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  leftIcon: _propTypes["default"].string,
  leftIconColor: _propTypes["default"].string,
  iconColor: _propTypes["default"].string,
  autocomplete: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  borderColor: _propTypes["default"].string,
  autoFocus: _propTypes["default"].bool,
  errorMsg: _propTypes["default"].string,
  name: _propTypes["default"].string,
  min: _propTypes["default"].string,
  showHelperText: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  loader: _propTypes["default"].node,
  loaderProps: _propTypes["default"].shape({
    size: _propTypes["default"].string,
    color: _propTypes["default"].string
  }),
  loaderAlign: _propTypes["default"].string
};
Input.defaultProps = {
  color: "white",
  hideLabel: false,
  disabled: false,
  value: "",
  type: "text",
  onChange: _noop2["default"],
  onBlur: _noop2["default"],
  onFocus: _noop2["default"],
  helperText: "",
  iconColor: "#B5B5B5",
  leftIconColor: "#B5B5B5",
  autocomplete: true,
  fullWidth: false,
  borderColor: _teal["default"].z500,
  autoFocus: false,
  errorMsg: "",
  showHelperText: true,
  loading: false,
  loaderProps: {
    color: "rgb(0,0,0)",
    size: "small"
  },
  loaderAlign: "right"
};
var _default = Input;
exports["default"] = _default;